import Select from "react-select";
import { Loading, QueryError } from "../../../components/Loading/Loading";
import { useFamilias } from "../../../hooks/Api/Familias";
import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";

interface FiltroMarcaProps {
	readonly familia: string;
	readonly setFamilia: (value: string) => void;
	readonly categoria: string | undefined;
	readonly setCategoria: (value: string | undefined) => void;
}
export function FiltroMarca(props: FiltroMarcaProps) {
	const queryFamilias = useFamilias();
	const queryCategorias = useCategorias();

	if (queryFamilias.error) return <QueryError error={queryFamilias.error} fallback="Error al cargar las familias" />;
	if (queryCategorias.error) return <QueryError error={queryCategorias.error} fallback="Error al cargar las categorías" />;
	if (queryFamilias.isPending || queryCategorias.isPending) return <Loading />;

	const categorias = queryCategorias.data.categorias;
	const familias = queryFamilias.data;

	const familiaValue = familias.find(item => props.familia == item.idFamilia);
	const categoriaValue = categorias.find(item => props.categoria == item);

	const optionsCategorias = categorias.map(cat => ({ value: cat, label: cat }));
	optionsCategorias.unshift({ value: "", label: "Sin categoría" });

	return (
		<div className="inputContainerGrid" role="tabpanel" style={{ padding: 30 }} >
			<label>Familia: </label>
			<Select
				options={familias.map((fam) => ({ value: fam.idFamilia, label: fam.nombreFamilia }))}
				className=""
				value={{ value: familiaValue?.idFamilia, label: familiaValue?.nombreFamilia }}
				onChange={(newValue) => props.setFamilia(newValue?.value ?? "")}
			/>

			<label>Categoria: </label>
			<Select
				options={optionsCategorias}
				className=""
				value={{ value: categoriaValue, label: categoriaValue }}
				onChange={(newValue) => props.setCategoria(newValue?.value)}
			/>
		</div>
	);
}

interface CategoriasRaw {
	categorias: string[];
}

function useCategorias() {
	return useQuery({
		queryKey: ["categoriasArticulos"],
		queryFn: () => {
			const url = "/api/v1/categorias";
			return ComunicacionAjax.sendAjaxRequest<CategoriasRaw>("GET", url, {});
		},
	});
}